import Vue from 'vue'

export const ProjectListModule = {
    strict: true, // for developement only
    namespaced: true,
    state: { 
        data: Array()
    },
    mutations: {
        setData: (state, payload = Array()) => {
            return state.data = payload
        }
    },
    getters: {
        getAllData: state => state.data,
        getProjectNames: state => state.data
    },
    actions: {
        async load({ commit, rootState }, params = Object()) {
            let res = await Vue.prototype.$http.post(rootState.apiUrl+"/project/list", params)
            commit('setData', res.data)
            return res.data
        }
    }
}